import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=5ee80d8c&scoped=true"
import script from "./rule.vue?vue&type=script&lang=js"
export * from "./rule.vue?vue&type=script&lang=js"
import style0 from "./rule.vue?vue&type=style&index=0&id=5ee80d8c&prod&lang=scss&scoped=true"
import style1 from "./rule.vue?vue&type=style&index=1&id=5ee80d8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee80d8c",
  null
  
)

export default component.exports